import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import { Link, useParams } from 'react-router-dom'
import { getArchiveShow } from '../api/api'
import moment from 'moment'
import NavLink from './navLink'

const Wzxq = () => {
  const [data, setData] = useState({})

  const { id = 1 } = useParams()
  console.log(useParams())

  useEffect(() => {
    getArchiveShow(`index/archiveShow?id=${id}`.replace('.html', '')).then(res => {
      setData(res?.data)
    })
    window.scrollTo(0, 0)
  }, [id])

  return (
    <Layout>
      <Subpages hidden="hidden" className="px-5 lg:px-0 mb-10 lg:mb-0" name={data?.channel?.name}>
        <div className="">
          <h2 className="mt-10 text-center text-[#333333] text-[20px] font-alhpr font-bold">
            {data?.titlea}
          </h2>
          <h1 className="mt-2 text-center text-[#333333] text-[26px] font-alhpr font-bold">
            {data?.title}
          </h1>
          <h2 className="text-center text-[#333333] font-alhpr font-bold mt-2">{data?.titles}</h2>
          <p className="text-center text-[#999999] font-alhpr mt-2">
            {data?.price} 发布日期：{moment(data?.publishtime * 1000).format('YYYY-MM-DD')}
          </p>
          <hr className="my-8" />
          <div dangerouslySetInnerHTML={{ __html: data?.content }} />
          <hr className="my-8" />
          <div className="flex text-[#333333] font-alhpr mt-2 font-bold">
            <p>上一篇：</p>
            <NavLink to={`/wzxq/id/${data?.prev_data?.id}`}>{data?.prev_data?.title}</NavLink>
          </div>
          <div className="flex text-[#333333] font-alhpr mt-2 font-bold">
            <p>下一篇：</p>
            <NavLink to={`/wzxq/id/${data?.next_data?.id}`}>{data?.next_data?.title}</NavLink>
          </div>
        </div>
      </Subpages>
    </Layout>
  )
}

export default Wzxq
